import { Button, Empty, List, Row } from 'antd';
import React, { useState } from 'react';
import { updateTrainerInfo } from '../../../services/trainerServices';
import CreationCard from './CreationCard';
import CreationsEdit from './CreationsEdit';

function Creations({ trainer, updateTrainerLocalData, updateTrainerData }) {
  const initialValues = {
    title: '',
    type: '',
    link: '',
    description: '',
  };

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [status, setStatus] = useState({ type: 'IDLE', message: 'Idle mode.' });

  function toggleAdd() {
    setIsAddOpen((prev) => !prev);
  }

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Loading data!' });
    let creations = [...trainer.creations];
    creations.push(values);
    let trainerData = {
      ...trainer,
      creations,
    };
    await updateTrainerData(trainerData)
      .then((response) => {
        console.log('Updated Trainer: ', response);
        updateTrainerLocalData(response.data.trainer);
        setStatus({ type: 'SUCCESS', message: 'Successful response' });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <div>
      <Row justify="space-between">
        <h2>Creations</h2>
        <Button onClick={toggleAdd} type="primary">
          Add
        </Button>
      </Row>
      {trainer.creations?.length ? (
        <List
          itemLayout="vertical"
          size="large"
          dataSource={trainer.creations}
          renderItem={(item, index) => (
            <CreationCard
              key={index}
              index={index}
              item={item}
              trainer={trainer}
              updateTrainerLocalData={updateTrainerLocalData}
              updateTrainerData={updateTrainerData}
            />
          )}
        />
      ) : (
        <Empty />
      )}
      <CreationsEdit
        type="ADD"
        initialValues={initialValues}
        isOpen={isAddOpen}
        status={status}
        toggle={toggleAdd}
        onSubmit={onSubmit}
      />
    </div>
  );
}

export default Creations;
